import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ServicesSection } from '../components/ServicesSection';
import { VirtualTryOn } from '../components/VirtualTryOn';
import { ContactLensOrderSection } from '../components/ContactLensOrderSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { ShopFramesSection } from '../components/ShopFramesSection';
import { PayBillSection } from '../components/PayBillSection';
export function ServicesPage() {
  return <>
      <PageHeader title="Our Services" backgroundImage="https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=1920&q=80" data-id="element-1099" />
      <ServicesSection data-id="element-1100" />
      <VirtualTryOn data-id="element-1101" />
      <ContactLensOrderSection data-id="element-1102" />
      <PayBillSection data-id="element-1103" />
      <ShopFramesSection data-id="element-1104" />
      <ReviewsSection data-id="element-1105" />
    </>;
}